/* src/app/calender/gcsetimetable/booking-modal/booking-modal.component.css */
.modal-container {
  background: #f5f5f5;
  padding: 20px;
  border-radius: 16px;
  text-align: center;
}
.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 16px;
}
.button-container {
  display: flex;
  justify-content: center;
  gap: 16px;
}
.exam-button {
  background: #e76f1c;
  color: white;
  font-size: 16px;
  font-weight: 500;
  padding: 12px 24px;
  border-radius: 50px;
  border: none;
  cursor: pointer;
  transition: background 0.3s ease;
}
.exam-button:hover {
  background: #d45f10;
}
@media (max-width: 768px) {
  .button-container {
    flex-direction: column;
    align-items: center;
  }
}
/*# sourceMappingURL=booking-modal.component.css.map */
